import { useState, FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../state/auth';
import { ApiError } from '../api/client';
import { Button } from '../components/Button';

export function Login() {
  const login = useAuthStore(s => s.login);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') ?? '/';

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await login(username, password);
      navigate(next, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError('Wrong username or password.');
      } else {
        setError('Login failed — check the server logs.');
      }
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm space-y-5 rounded-2xl bg-zinc-900 p-8 shadow-2xl ring-1 ring-zinc-800"
      >
        <div>
          <h1 className="text-2xl font-semibold">Dev Board</h1>
          <p className="mt-1 text-sm text-zinc-400">Sign in to continue</p>
        </div>

        <label className="block text-sm">
          <span className="text-zinc-300">Username</span>
          <input
            className="mt-1 block w-full rounded-md bg-zinc-800 px-3 py-2 ring-1 ring-zinc-700 focus:ring-2 focus:ring-brand-500 focus:outline-none"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
            required
          />
        </label>

        <label className="block text-sm">
          <span className="text-zinc-300">Password</span>
          <input
            type="password"
            className="mt-1 block w-full rounded-md bg-zinc-800 px-3 py-2 ring-1 ring-zinc-700 focus:ring-2 focus:ring-brand-500 focus:outline-none"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </label>

        {error && <p className="text-sm text-red-400">{error}</p>}

        <Button type="submit" loading={pending} className="w-full justify-center">
          Sign in
        </Button>
      </form>
    </div>
  );
}
